/** Decimal arithmetic for the three-decimal physical stock contract. */
function decimalParts(value: number): { coefficient: bigint; scale: number } {
  const [mantissa = '0', exponent = '0'] = String(value).split('e');
  const [whole = '0', fraction = ''] = mantissa.split('.');
  return {
    coefficient: BigInt(whole + fraction),
    scale: fraction.length - Number(exponent),
  };
}

function roundedQuantity(coefficient: bigint, scale: number): number {
  if (scale <= 3) return Number(coefficient * 10n ** BigInt(3 - scale)) / 1000;
  const divisor = 10n ** BigInt(scale - 3);
  const magnitude = coefficient < 0n ? -coefficient : coefficient;
  const millimes = (magnitude + divisor / 2n) / divisor;
  return Number(coefficient < 0n ? -millimes : millimes) / 1000;
}

export function roundStockQuantity(value: number): number {
  if (!Number.isFinite(value)) return value;
  const decimal = decimalParts(value);
  return roundedQuantity(decimal.coefficient, decimal.scale);
}

/**
 * Match NUMERIC round(quantity * unit_factor, 3). Multiplying JS numbers first
 * loses exact decimal halves: 1.001 * 0.5 otherwise rounds to 0.500, not 0.501.
 * Number's decimal string is also the value serialized in the RPC payload.
 */
export function physicalStockQuantity(quantity: number, factor: number): number {
  if (!Number.isFinite(quantity) || !Number.isFinite(factor)) return Number.NaN;
  const left = decimalParts(quantity);
  const right = decimalParts(factor);
  return roundedQuantity(left.coefficient * right.coefficient, left.scale + right.scale);
}
